export enum Grid {
  FullHd = '1840px',
  BigDesktop = '1600px',
  Desktop = '1520px',
  DesktopHalf = '740px',
}
